import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import API from '../common/API';
import * as Actions from '../actions/Mail';
import { waitAuthorizedCheck } from './Auth';

function* resendMail(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.post,
            {
                endpoint: '/api/v1/user/resend_account/',
                body: {
                    user_id: action.payload.user_id,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.ResendMailRequestedReceived(response));
    } catch (error) {
        yield put(Actions.ResendMailRequestedReceivedFailure(yield error));
    }
}

export default function* mail() {
    yield all([
        takeLatest('RESEND_MAIL_REQUESTED', resendMail),
    ]);
}
